/**
 * HomeARAlmadarHomePageView
 *
 * Page component for HomeARAlmadarHomePageView
 * Path: /ar
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { HomeARAlmadarHomePageView as __HomeARAlmadarHomePageView } from '@/components/traits/HomeARAlmadarHomePageView';
import { HomeARHomeAnalyticsView as __HomeARHomeAnalyticsView } from '@/components/traits/HomeARHomeAnalyticsView';
import { HomeARDemoTicketDeskView as __HomeARDemoTicketDeskView } from '@/components/traits/HomeARDemoTicketDeskView';
import { HomeARDemoStockPageDeskView as __HomeARDemoStockPageDeskView } from '@/components/traits/HomeARDemoStockPageDeskView';
import { HomeARDemoPeopleDeskView as __HomeARDemoPeopleDeskView } from '@/components/traits/HomeARDemoPeopleDeskView';
import { HomeARDemoInvoicePageDeskView as __HomeARDemoInvoicePageDeskView } from '@/components/traits/HomeARDemoInvoicePageDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface HomeARAlmadarHomePageViewProps {
  // Add any page-level props here
}

export function HomeARAlmadarHomePageView(_props: HomeARAlmadarHomePageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-home:meta.title"],"description":["i18n/t","std-almadar-home:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/"},{"locale":"ar","path":"/ar"},{"locale":"sl","path":"/sl"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__HomeARAlmadarHomePageView config={{ initPayload: __navState }} />
          <__HomeARHomeAnalyticsView config={{ initPayload: __navState }} />
          <__HomeARDemoTicketDeskView config={{ initPayload: __navState }} />
          <__HomeARDemoStockPageDeskView config={{ initPayload: __navState }} />
          <__HomeARDemoPeopleDeskView config={{ initPayload: __navState }} />
          <__HomeARDemoInvoicePageDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default HomeARAlmadarHomePageView;
